import React from "react";
import "../styles/disasterDashboard.css";

export const DisasterAlert = ({
  weatherData,
  alerts,
  loading,
  locationError,
}) => {
  return (
    <div className="disaster-alert-main-container">
      <div className="disaster-alert-left">
        <div className="disaster-alert-main-heading">ALERT !</div>
        <div className="disaster-alert-date-time">
          {loading ? (
            <div>Loading...</div>
          ) : locationError ? (
            <div className="disaster-alert-date-time">{locationError}</div>
          ) : weatherData ? (
            <>
              <div className="disaster-alert-date-time">
                Condition:{" "}
                {weatherData.condition &&
                  weatherData.condition.text &&
                  weatherData.condition.text}
              </div>
              <div className="disaster-alert-date-time">
                Temp: {weatherData.temp_c}°C / {weatherData.temp_f}°F
              </div>
              <div className="disaster-alert-date-time">
                Wind: {weatherData.wind_mph && weatherData.wind_mph} mph
              </div>
            </>
          ) : (
            <div>No weather data available.</div>
          )}
        </div>
      </div>
      <div className="disaster-alert-right">
        <div className="disaster-alert-main-sub-heading">
          {alerts.length > 0 ? (
            Array.from(
                new Map(
                  alerts
                    .filter((alert) => alert.msgtype === "Alert")
                    .map((alert) => [
                      `${alert.headline}-${alert.event}-${alert.effective}`,
                      alert
                    ])
                ).values()
              ).map((alert, index) => (
              <div key={index} className="disaster-alert-main-sub-heading">
                <strong>{alert.headline}</strong>
                <div>Effective: {alert.effective}</div>
                <div>Expires: {alert.expires}</div>
                <div>{alert.desc}</div>
                <div>{alert.instruction}</div>
              </div>
            ))
          ) : (
            <div className="disaster-alert-main-sub-heading">
              No current alerts for your area.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
